var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal__item-row" },
      [
        _c("TextEditor", {
          model: {
            value: _vm.note,
            callback: function($$v) {
              _vm.note = $$v
            },
            expression: "note"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "grid modal__item-row" }, [
      _c("div", { staticClass: "grid__col--4" }),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--4" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { disabled: !_vm.formValid },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.submitComment($event)
              }
            }
          },
          [_vm._v("Submit Comment")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--4" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }